import { render, staticRenderFns } from "./MediaEdit.vue?vue&type=template&id=e72a2dda&"
import script from "./MediaEdit.vue?vue&type=script&lang=js&"
export * from "./MediaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports